module.exports = __webpack_public_path__ + "img/add-way-3.5462ec4c.png";